import { h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import FieldError from "./FieldError";
function LocateMeButton(props) {
    const isVisible = !(window.Skubacz.Device.isMobileApp() &&
        !window.Skubacz.Device.mobileGeolocationEnabled());
    if (!isVisible) {
        return null;
    }
    const { onLocateMe, isLoading = false, geolocationError } = props;
    const hasGeolocationError = geolocationError !== undefined && geolocationError !== null;
    return (h("div", { class: `form-group m-form__group u-full-width ${hasGeolocationError ? "has-error" : ""}` },
        h("button", { onClick: onLocateMe, type: "button", class: "btn btn-link u-p0 u-box-shadow-none", "data-field-id": "fulfillmentMethod.deliveryAddress.locateMe", disabled: isLoading },
            h("span", { "aria-hidden": "true", class: "icon-target u-font-size-120p" }),
            translate(t.delivery_method.locate_me)),
        hasGeolocationError && h(FieldError, { errors: [geolocationError] })));
}
export default observer(LocateMeButton);
